import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[NumberOnly]',
    standalone: false
})
export class NumberOnlyDirective {

  private readonly regex: RegExp = new RegExp('^\d*$');
  private readonly specialKeys: Array<string> = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
  constructor(private readonly elementRef: ElementRef) { }

  /**
   * Key board action
   * @param event 
   */
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const inputValue: string = this.elementRef.nativeElement.value.concat(event.key);
    if (inputValue && !String(inputValue).match(this.regex)) {
      event.preventDefault();
    }
  }

  /**
   * Copy Paste action 
   * @param event 
   */
  @HostListener('paste', ['$event']) onPaste(event) {
    const clipboardData = (event.originalEvent || event).clipboardData.getData('text/plain');
    if (clipboardData && !this.regex.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
